'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$() {
  this.jY = null;
  this.lU = null;
  this.jY = $j_java$002elang$002e$002dObject.$bL(2036907392, 73);
  this.lU = $j_java$002elang$002e$002dObject.$bL(2037677056, 14);
}
export { $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$ as $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$ };
$p = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$() {
}
export { $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$ as $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$ };
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$.prototype = $p;
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$, "java.time.format.internal.TTBPDateTimeFormatterBuilder$InstantPrinterParser$", ({
  lz: 1
}));
export { $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$ as $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$ };
var $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$;
function $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$() {
  if ((!$n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$)) {
    $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$ = new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$();
  }
  return $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$;
}
export { $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$ as $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$ };
